import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from '../components/Navigation';
import PriceList from '../components/PriceList';
import Footer from '../components/Footer';

const PriceListPage = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pearl-50 via-ocean-25 to-jade-50">
      <Navigation />
      
      {/* Hero Section Premium - Mobile First */}
      <motion.div 
        className="relative bg-gradient-to-br from-ocean-600 via-ocean-700 to-jade-700 text-white pt-20 pb-12 px-4 sm:pt-24 sm:pb-16 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Efectos de fondo animados */}
        <div className="absolute inset-0 bg-gradient-to-br from-ocean-500/20 via-transparent to-jade-500/20"></div>
        <motion.div
          className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl"
          animate={{
            x: [0, 100, 0],
            y: [0, -50, 0],
            scale: [1, 1.2, 1]
          }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute bottom-20 right-10 w-32 h-32 bg-jade-400/10 rounded-full blur-2xl"
          animate={{
            x: [0, -80, 0],
            y: [0, 40, 0],
            scale: [1, 0.8, 1]
          }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        />
        
        <div className="container mx-auto text-center relative z-10 max-w-4xl">
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 font-title leading-tight">
              <span className="block text-white drop-shadow-lg">Catálogo</span>
            </h1>
          </motion.div>
          
          <motion.p 
            className="text-base sm:text-lg md:text-xl lg:text-2xl text-pearl-100 max-w-3xl mx-auto mb-4 sm:mb-6 leading-relaxed px-4"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Ostras y mariscos premium de la Patagonia Argentina
          </motion.p>
          
          <motion.div
            className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 text-sm sm:text-base"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full border border-white/30">
              <div className="w-2 h-2 bg-seagreen-400 rounded-full animate-pulse"></div>
              <span className="font-medium">Productos frescos disponibles</span>
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <span className="text-pearl-200">Actualizado: Agosto 2025</span>
            </div>
          </motion.div>
        </div>

        {/* Decorative waves */}
        <div className="absolute bottom-0 left-0 right-0 h-12 sm:h-16 md:h-20">
          <svg className="w-full h-full" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,80 C400,20 800,120 1200,40 L1200,120 L0,120 Z" fill="rgb(254, 252, 246)" opacity="0.9"/>
            <path d="M0,100 C600,60 1000,40 1200,80 L1200,120 L0,120 Z" fill="rgb(254, 252, 246)"/>
          </svg>
        </div>
      </motion.div>
      
      {/* Price List Content con mejoras visuales */}
      <motion.div 
        className="relative -mt-8 sm:-mt-12 z-10"
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <PriceList />
      </motion.div>
      
      <Footer />
    </div>
  );
};

export default PriceListPage;
